export default __webpack_public_path__ + "static/media/bird_green.24372de1.svg";